import React, { Component } from 'react';
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Footer from "../../../common_components/Footer";
import Header from "../../../common_components/Header";
import { withRouter } from "../../../utils/withRouter";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
// 
class Trade_enquiry extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
        }
        this.slider3Ref = React.createRef()
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        const { isLoading } = this.state

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                {/* <ToastContainer />. */}
                <Header />


                <div
                    className="breadcrumb-wrapper bg-cover"
                    style={{ backgroundImage: 'url("assets/img/breadcrumb.jpg")' }}
                >
                    <div className="border-shape">
                        <img src="assets/img/element_1.png" alt="shape-img" />
                    </div>
                    <div className="line-shape">
                        <img src="assets/img/line-element.png" alt="shape-img" />
                    </div>
                    <div className="container">
                        <div className="page-heading">
                            <h1 className="wow fadeInUp" data-wow-delay=".3s">
                                Trade Enquiry
                            </h1>
                            <ul className="breadcrumb-items wow fadeInUp" data-wow-delay=".5s">
                                <Link to='/'><li>Home </li></Link>
                                <li>
                                    <i className="fa fa-chevron-right" />
                                </li>
                                <li>Services</li>
                                <li>
                                    <i className="fa fa-chevron-right" />
                                </li>
                                <li>Trade Enquiry</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <section
                    className="about-section section-padding fix bg-cover"
                    style={{ backgroundImage: 'url("assets/img/service/service-bg-2.jpg")' }}
                >
                    <div className="container">
                        <div className="about-wrapper style-2">
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="about-image-items">
                                        <div className="circle-shape">
                                            <img src="assets/img/about/circle.png" alt="shape-img" />
                                        </div>
                                        <div
                                            className="about-image-1 bg-cover wow fadeInLeft"
                                            data-wow-delay=".3s"
                                            style={{ backgroundImage: 'url("assets/img/trade_enquiry_img.png")' }}
                                        >
                                            <div className="about-image-2 wow fadeInUp" data-wow-delay=".5s">
                                                <img src="assets/img/about/04.jpg" alt="about-img" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-6 mt-4 mt-lg-0">
                                    <div className="about-content">
                                        <div className="section-title mb-3 mxw-650">
                                            <div className="subtitle">
                                                {" "}
                                                <img src="assets/img/icon/arrowLeft.svg" alt="icon" />{" "}
                                                <span>Trade Enquiry</span>
                                                <img src="assets/img/icon/arrowRight.svg" alt="icon" />
                                            </div>
                                            <h2 className="title">business opportunities</h2>
                                        </div>
                                        <p className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                                            Trade enquiry service connects members with potential business
                                            opportunities. Whether you're looking to find buyers, suppliers,
                                            or strategic partners, we facilitate the best deals by linking you
                                            with relevant stakeholders across the textile machinery industry.
                                        </p>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div
                                                    className="why_india_css wow fadeInUp"
                                                    data-wow-delay=".6s"
                                                >
                                                    <h6 style={{ fontSize: 16 }}>Sourcing </h6>
                                                    <ul>
                                                        <li>Mapping trade requests</li>
                                                        <li>Handling queries</li>
                                                        <li>Providing pre-requisite information</li>
                                                        <li>Connecting with the right partners</li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div
                                                    className="why_india_css wow fadeInUp"
                                                    data-wow-delay=".7s"
                                                >
                                                    <h6 style={{ fontSize: 16 }}>Consulting</h6>
                                                    <ul>
                                                        <li>Handling project enquiries</li>
                                                        <li>Proposal preparation</li>
                                                        <li>Proposal Follow up</li>
                                                        <li>Project Co-ordination</li>
                                                        <li>Project Handholding</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div class="about-author">
                          <div class="about-button wow fadeInUp" data-wow-delay=".5s">
                              <a href="about.html" class="theme-btn">
                                  Explore More
                                  <i class="fa-solid fa-arrow-right-long"></i>
                              </a>
                          </div>
                      </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>



                <Footer />
            </>
        )

    }
}
// ReactDOM.render(<Homepage />, document.querySelector('.demo-carousel'))

export default withRouter(connect(null, {})(Trade_enquiry));